import React, { useEffect, useState } from "react";
import { usePromiseTracker } from "react-promise-tracker";
// import { ColorRing } from "react-loader-spinner";

import { Box, Center, Portal, Spinner } from "@metrea-ui/v2";
// import styles from "./LoadingSpinner.css";
import { mColor } from "src/utils/themeUtils";

/* 
	<LoadingIndicator /> // shows only during promiseInProgress
	<LoadingIndicator forceShow={true} /> // show indefinitely
	<LoadingIndicator forceShow={true} duration={10000} /> // show for 10 seconds
*/

export const LoadingIndicator = ({
	forceShow = false,
	duration = 0, // ms; 0 = infinite
}) => {
	const { promiseInProgress } = usePromiseTracker();
	const [timerActive, setTimerActive] = useState(false);

	useEffect(() => {
		let timer;
		if (forceShow && duration > 0) {
			setTimerActive(true);
			timer = setTimeout(() => setTimerActive(false), duration);
		} else if (forceShow) {
			setTimerActive(true);
		} else {
			setTimerActive(false);
		}
		return () => clearTimeout(timer);
	}, [forceShow, duration]);

	const shouldShow = promiseInProgress || timerActive;

	if (!shouldShow) return null;

	return (
		<Portal>
			<Box pos="absolute" inset="0" bg="bg/70">
				<Center h="30%">
					<Spinner size="xl" color={mColor.StonyBlue} thickness="6px" />
				</Center>
			</Box>
		</Portal>
	);
};

